var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPayInThree(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    width: 28,
    height: 28
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "icon-pay-in-three_svg__s0",
    d: "m24.3 14c0 5.7-4.6 10.3-10.3 10.3-5.7 0-10.3-4.6-10.3-10.3 0-5.7 4.6-10.3 10.3-10.3 5.7 0 10.3 4.6 10.3 10.3zm-10.3-8.6c-4.7 0-8.6 3.9-8.6 8.6 0 4.7 3.9 8.6 8.6 8.6 4.7 0 8.6-3.9 8.6-8.6 0-4.7-3.9-8.6-8.6-8.6z",
    fill: "#1E82F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "icon-pay-in-three_svg__s0",
    d: "m14 14l5.9 3.4c0.6-1 1-2.2 1-3.4 0-3.8-3.1-6.9-6.9-6.9z",
    fill: "#1E82F0"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDI4IDI4IiB3aWR0aD0iMjgiIGhlaWdodD0iMjgiPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsYXNzPSJzMCIgZD0ibTI0LjMgMTRjMCA1LjctNC42IDEwLjMtMTAuMyAxMC4zLTUuNyAwLTEwLjMtNC42LTEwLjMtMTAuMyAwLTUuNyA0LjYtMTAuMyAxMC4zLTEwLjMgNS43IDAgMTAuMyA0LjYgMTAuMyAxMC4zem0tMTAuMy04LjZjLTQuNyAwLTguNiAzLjktOC42IDguNiAwIDQuNyAzLjkgOC42IDguNiA4LjYgNC43IDAgOC42LTMuOSA4LjYtOC42IDAtNC43LTMuOS04LjYtOC42LTguNnoiIGZpbGw9IiMxRTgyRjAiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGFzcz0iczAiIGQ9Im0xNCAxNGw1LjkgMy40YzAuNi0xIDEtMi4yIDEtMy40IDAtMy44LTMuMS02LjktNi45LTYuOXoiIGZpbGw9IiMxRTgyRjAiLz4KPC9zdmc+Cg==";
export { SvgIconPayInThree as ReactComponent };